import { IBaseComponentProps } from '../props/IBaseComponentProps';
import { NSBarTitleProps } from './NSBarTitle';
import { NSSection } from './NSSection';
import Styles from './NSBarAlert.module.css';

export interface NSBarAlertProps extends IBaseComponentProps
{
	title: NSBarTitleProps;
	button_text?: string;
	isVisible: () => boolean;
	onClick?: () => void;
}

export function NSBarAlert(props: NSBarAlertProps)
{
	return (
		<article
			id={props.id}
			className={`${Styles.ns_bar_alert_section} ${props.classList?.join(" ") ?? ""}`}
			style={props.style}
		>
			<NSSection style={props.style} classList={[Styles.ns_bar_alert_container]}>
				<div className={Styles.ns_bar_alert_title_parent}>
					<div className={Styles.ns_bar_alert_title}>
						<img src="https://static.namirasoft.com/image/concept/alarm/blue.svg" alt="Alarm" width={24} height={24} />
						<h3> {props.title.title} </h3>
					</div>
					<p className={Styles.ns_bar_alert_description}>{props.title.description}</p>
				</div>
				<div className={Styles.ns_bar_alert_link}>
					<button onClick={props.onClick}>{props.button_text ?? "Continue"}</button>
				</div>
			</NSSection>
		</article>
	);
}